/************
 Product Swiper
 ************/

// setup product swiper
const productSwiper = new Swiper(document.querySelector(".productBodyWrapVisualSwiper"), {
    slidesPerView: 1,
    spaceBetween: 15,
    loop: true,
    on: {
        slideChange: function () {
            // update the thumbnail active class
            document.querySelector(".productBodyWrapVisualThumbsSlide.active").classList.remove("active");
            document.querySelectorAll(".productBodyWrapVisualThumbsSlide")[this.realIndex].classList.add("active");

            // pause all videos
            document.querySelectorAll(".productBodyWrapVisualSwiperSlide video").forEach(element => {
                element.pause();
            });
        }
    }
});

// play video on slide play click
document.querySelectorAll(".productBodyWrapVisualSwiperSlide").forEach(element => {
    element.addEventListener("click", function () {
        // get video
        const video = this.closest(".productBodyWrapVisualSwiperSlide").querySelector("video");

        // remove play button
        this.querySelector(".productBodyWrapVisualSwiperSlidePlay").remove();

        // show controls
        video.controls = true;

        // play video
        video.play();
    });
});

// change slide on thumbnail click
document.querySelectorAll(".productBodyWrapVisualThumbsSlide").forEach(element => {
    element.addEventListener("click", function () {
        // change slide
        productSwiper.slideTo(this.dataset.index - 1);
    });
});


/**************
 Product Variants
 ***************/

// update active variant on input changes
document.querySelectorAll("#product input").forEach(function (element) {
    element.addEventListener("change", function () {
        updateProduct();
    });
})


let quantity = 1;

// update active variant
function updateProduct() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productBodyContentControlsOptionsItem`).forEach(group => {
        options.push(group.querySelector(`input:checked`).value);
    });

    // if options are empty, there are no variants,
    // set the first variant as active
    if (options.length === 0) {
        activeVariant = product.variants[0];
    } else {
        // find new variant based on the options
        activeVariant = product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(options)
        });
    }

    // check if variant wasn't found
    if (activeVariant === null) {
        document.querySelector("#productBodyContentControlsBodyATC").disabled = true;
        document.querySelector("#productBodyContentControlsBodyATC").textContent = "Not Available";
        return;
    }

    // update price
    document.querySelector("#productBodyContentControlsBodyPriceContentCompareReal").textContent = price(activeVariant.price * quantity);
    if (activeVariant.compare_at_price > activeVariant.price) {
        document.querySelector("#productBodyContentControlsBodyPriceContentCompare")?.classList.remove("active");
        document.querySelector("#productBodyContentControlsBodyPriceContentCompare").textContent = price(activeVariant.compare_at_price * quantity);
    } else {
        document.querySelector("#productBodyContentControlsBodyPriceContentCompare")?.classList.add("active");
    }

    // check if the variant is in stock
    if (activeVariant.available) {
        document.querySelector("#productBodyContentControlsBodyATC").classList.add("primary");
        document.querySelector("#productBodyContentControlsBodyATC").disabled = false;
        document.querySelector("#productBodyContentControlsBodyATC").textContent = "Add To Cart";
    } else {
        document.querySelector("#productBodyContentControlsBodyATC").classList.remove("primary");
        document.querySelector("#productBodyContentControlsBodyATC").disabled = true;
        document.querySelector("#productBodyContentControlsBodyATC").textContent = "Sold Out";
    }

    // update subscription
    document.querySelectorAll('.subscriptionSavings')?.forEach(element => {
        element.textContent = document.querySelector('.productBodyContentControlsSubscriptionDropBodyWrapContentLabelInput:checked')?.dataset.savings;
    });

    // update price
    if (document.querySelector('.productBodyContentControlsSubscriptionDropInput')?.checked) {
        let save = parseInt(document.querySelector('.productBodyContentControlsSubscriptionDropBodyWrapContentLabelInput:checked').dataset.savings) / 100;
        let updatedPrice = (activeVariant.price * quantity) - ((activeVariant.price * quantity) * save);
        document.querySelector("#productBodyContentControlsBodyPriceContentCompareReal").textContent = price(updatedPrice);
    }
}

// listen for subscription dropdown
document.querySelector('input.productBodyContentControlsSubscriptionDropInput')?.addEventListener('change', function () {
    document.querySelector('.productBodyContentControlsSubscriptionDropBody').classList.toggle('active');
});


/****************
 * Product Quantity
 */


// minus
document.querySelector("#productBodyContentControlsQtyBtnsMinus")?.addEventListener("click", function () {
    if (quantity === 1) {
        return;
    }
    quantity--;
    document.querySelector("#productBodyContentControlsQtyBtnsValue").textContent = quantity;
    updateProduct();
});

// plus
document.querySelector("#productBodyContentControlsQtyBtnsPlus")?.addEventListener("click", function () {
    quantity++;
    document.querySelector("#productBodyContentControlsQtyBtnsValue").textContent = quantity;
    updateProduct();
});


/**************
 Product ATC
 ***************/

document.querySelector("#productBodyContentControlsBodyATC").addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");

    let formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id,
        }]
    };

    // check for subscription
    if (document.querySelector('.productBodyContentControlsSubscriptionDropInput')?.checked) {
        // add to form data
        formData.items[0].selling_plan = parseInt(document.querySelector('.productBodyContentControlsSubscriptionDropBodyWrapContentLabelInput:checked').value);
    }

    // add product
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});